import { required, numeric, maxValue, helpers } from '@vuelidate/validators';
import i18n from "@/plugins/i18n";

export default function (formState) {
  return {
    recipe: {
      inventory_id: {
        required: helpers.withMessage(i18n.global.t('Please select an ingredient.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number.'), numeric)
      },
      quantity_system: {
        required: helpers.withMessage(i18n.global.t('Please enter a quantity system.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the quantity system.'), numeric)
      },
      quantity_display: {
        required: helpers.withMessage(i18n.global.t('Please enter a quantity display.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number for the quantity display.'), numeric),
        maxValue: helpers.withMessage(i18n.global.t('Display quantity must not exceed system quantity.'), maxValue(formState.quantity_system))
      },
      unit_id: {
        required: helpers.withMessage(i18n.global.t('Please select a unit.'), required),
        numeric: helpers.withMessage(i18n.global.t('Please enter a valid number.'), numeric)
      }
    }
  }
};
